<template>
  <section class="settings-list-panel" aria-labelledby="users-title">
    <div class="settings-section-heading">
      <div>
        <span class="settings-eyebrow">Acessos</span>
        <h2 id="users-title">Usuários do app</h2>
        <p>Veja quem acessa o financeiro e mantenha os dados de contato visíveis.</p>
      </div>

    </div>

    <template v-if="getAllUsersList.length">
      <div class="settings-table-wrap">
        <table class="settings-data-table">
          <thead>
            <tr>
              <th scope="col">Usuário</th>
              <th scope="col">Telefone</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in getAllUsersList" :key="user.id || user.email">
              <td>
                <div class="settings-primary-cell">
                  <span class="settings-avatar"><i class="ph ph-user" aria-hidden="true"></i></span>
                  <div>
                    <strong>{{ user.name || 'Usuário sem nome' }}</strong>
                    <span>{{ user.email || 'Sem e-mail cadastrado' }}</span>
                  </div>
                </div>
              </td>
              <td>{{ formatPhone(user.phone) }}</td>
              <td>
                <span class="status-pill" :class="isActive(user) ? 'is-active' : 'is-inactive'">
                  {{ isActive(user) ? 'Ativo' : 'Inativo' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="settings-mobile-list">
        <article v-for="user in getAllUsersList" :key="`mobile-${user.id || user.email}`" class="settings-mobile-card">
          <div class="settings-mobile-card__top">
            <span class="settings-avatar"><i class="ph ph-user" aria-hidden="true"></i></span>
            <div class="settings-primary-cell">
              <div>
                <strong>{{ user.name || 'Usuário sem nome' }}</strong>
                <span>{{ user.email || 'Sem e-mail cadastrado' }}</span>
              </div>
            </div>
            <span class="status-pill" :class="isActive(user) ? 'is-active' : 'is-inactive'">
              {{ isActive(user) ? 'Ativo' : 'Inativo' }}
            </span>
          </div>

          <div class="settings-mobile-card__body">
            <span><strong>Telefone:</strong> {{ formatPhone(user.phone) }}</span>
          </div>

        </article>
      </div>
    </template>

    <div v-else class="settings-list-empty">
      <span><i class="ph ph-users" aria-hidden="true"></i></span>
      <strong>Nenhum usuário cadastrado</strong>
      <p>Os usuários já cadastrados nesta conta aparecerão aqui.</p>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

type User = {
  id?: number | string;
  name?: string;
  email?: string;
  phone?: string;
  active?: boolean | number | string;
};

export default defineComponent({
  name: "UsersList",
  computed: {
    ...mapGetters([
      "getAllUsersList",
    ]),
  },
  methods: {
    isActive(user: User): boolean {
      return user.active === 1 || user.active === true || user.active === "1";
    },
    formatPhone(value?: string): string {
      let digits = String(value || "").replace(/\D/g, "");
      if (!digits) return "Sem telefone";

      let countryPrefix = "";
      if (digits.startsWith("55") && digits.length > 11) {
        countryPrefix = "+55 ";
        digits = digits.slice(2);
      }

      const areaCode = digits.slice(0, 2);
      const number = digits.slice(2, 11);
      const splitAt = number.length > 8 ? 5 : 4;
      const firstPart = number.slice(0, splitAt);
      const secondPart = number.slice(splitAt);

      return `${countryPrefix}(${areaCode}) ${firstPart}${secondPart ? `-${secondPart}` : ""}`;
    },
  },
});
</script>
